(() => {
  window.LSFitFinderCategories = window.LSFitFinderCategories || {};
  window.LSFitFinderCategories.seed = {
    restartStep: 'sun',
    initialize(ctx) {
      ctx.cards = Array.from(ctx.root.querySelectorAll('[data-fit-recommendation]'));
      ctx.currentProductId = String(ctx.root.dataset.currentProductId || '');
      ctx.currentProductHandle = ctx.normalize(ctx.root.dataset.currentProductHandle || '');
      ctx.productRegions = String(ctx.root.dataset.productRegions || '').split(',').map(ctx.normalize).filter(Boolean);
    },
    clear(ctx) { ctx.cards?.forEach((card) => { card.hidden = true; }); },
    find(ctx) {
      const option = ctx.normalize(ctx.answers.sunValue), region = ctx.normalize(ctx.answers.region);
      return ctx.cards.filter((card) => {
        const sourceId = String(card.dataset.sourceProduct || ''), sourceHandle = ctx.normalize(card.dataset.sourceProductHandle || '');
        if (sourceHandle && sourceHandle !== ctx.currentProductHandle) return false;
        if (!sourceHandle && sourceId && sourceId !== ctx.currentProductId) return false;
        if (ctx.normalize(card.dataset.recommendedProductHandle) === ctx.currentProductHandle) return false;
        const parseValues = (value) => {
          if (!value) return [];
          try {
            const parsed = JSON.parse(value);
            return (Array.isArray(parsed) ? parsed : [parsed]).map(ctx.normalize).filter(Boolean);
          } catch (error) {
            return String(value).split(',').map(ctx.normalize).filter(Boolean);
          }
        };
        const triggerOptions = parseValues(card.dataset.triggerOptions || card.dataset.triggerOption);
        const triggerRegions = parseValues(card.dataset.triggerRegions || card.dataset.triggerRegion);
        return (!triggerOptions.length || triggerOptions.includes(option)) && (!triggerRegions.length || triggerRegions.includes(region));
      }).sort((a, b) => {
        const specificity = (card) => {
          const options = card.dataset.triggerOptions || card.dataset.triggerOption;
          const regions = card.dataset.triggerRegions || card.dataset.triggerRegion;
          return (options ? 1 : 0) + (regions ? 1 : 0);
        };
        return specificity(b) - specificity(a) || Number(a.dataset.priority || 999) - Number(b.dataset.priority || 999);
      })[0] || null;
    },
    showRecommendation(ctx, card, message) {
      ctx.showResult({ match: false, icon: '→', title: 'Different seed recommended', copy: message || card.dataset.customerMessage || 'A different seed is a better match for your lawn.' });
      card.hidden = false;
    },
    showResult(ctx) {
      const recommendation = this.find(ctx);
      if (recommendation) return this.showRecommendation(ctx, recommendation);
      const matchesRegion = !ctx.productRegions.length || ctx.productRegions.includes(ctx.normalize(ctx.answers.region));
      if (!matchesRegion) return ctx.showMismatch('region', ctx.answers.region || 'this region');
      const velocity = ctx.normalize(ctx.root.dataset.productTitle).includes('velocity');
      const stateName = ctx.el.stateSelect?.options[ctx.el.stateSelect.selectedIndex]?.text || '';
      ctx.showResult({
        match: true, icon: '✓', title: velocity ? 'Velocity is a great choice' : 'Yes — this is a good choice',
        copy: velocity ? (ctx.normalize(ctx.answers.region) === 'northern' ? 'Velocity is a strong option for repairing or overseeding northern cool-season lawns.' : 'Velocity is a great choice for fall overseeding warm-season lawns for winter color.') : (stateName ? (ctx.root.dataset.productTitle || 'This product') + ' is a good fit for ' + ctx.answers.sun.toLowerCase() + ' conditions in ' + stateName + '.' : (ctx.root.dataset.productTitle || 'This product') + ' is a good fit for these conditions.')
      });
    },
    onOption(ctx, option) {
      const type = option.dataset.fitType, supported = option.dataset.fitSupported === 'true', label = option.dataset.fitLabel || 'your selection';
      if (type === 'grass') {
        if (!supported) { const rule = this.find(ctx); return rule ? this.showRecommendation(ctx, rule) : ctx.showMismatch(type, label); }
        ctx.showStep('sun'); return;
      }
      if (type !== 'sun') return;
      if (!ctx.answers.state) {
        const savedStateCode = String(ctx.el.stateSelect?.value || '').toUpperCase();
        if (savedStateCode && ctx.applyState) return ctx.applyState(savedStateCode, true);
        if (!ctx.state.lookupFinished) return;
        return ctx.requestState();
      }
      const rule = this.find(ctx);
      if (rule) return this.showRecommendation(ctx, rule, 'For these conditions, we recommend a different seed.');
      if (!supported) return ctx.showMismatch(type, label);
      this.showResult(ctx);
    },
    onState(ctx) { if (ctx.answers.sunValue) this.showResult(ctx); },
    onLookupMiss(ctx) { ctx.el.statePrompt.textContent = 'Where is your lawn located?'; ctx.el.stateSelect.hidden = false; ctx.el.stateContinue.hidden = false; ctx.el.stateContinue.disabled = true; },
    onLookupFinished(ctx) { if (ctx.answers.sunValue && !ctx.answers.state) ctx.requestState(); }
  };
})();
